<template lang="pug">
  //- 最初はlocalUserがundefined（peerIdが無い）ため
  div(v-if="localUser")
    video.video(
      v-if="localUser.cameraFlag"
      class="video--own",
      :style="layoutCover",
      :srcObject.prop="localStream",
      muted,
      autoplay,
      playsinline,
      @click="changeMainStream"
    )
    .video(
      v-else,
      @click="changeMainStream"
    )
      .video__wrapper-user
        .video__user-icon
          img.video__user-img.video__user-img--own(
            :class="{ 'is-sidebar': layoutSubFlag }",
            :src="localUser.icon || '/static/img/app/user-icon.svg'",
            @click="inputFile"
          )
          input.d-none.form-control-file(
            ref="inputFile",
            type="file",
            @change="uploadImg",
            accept="image/*"
          )

          button.video__close-button(
            v-show="!layoutSubFlag",
            type="button",
            @click="removeIcon"
          )
            img.video-controller__icon(src="/static/img/app/btn-leave.svg")
        .video__user-name(
          v-show="!layoutSubFlag",
          :class="{ 'video__user-name--small': layoutSubFlag }"
        )
          | {{ localName }}
    .video-wrapper__user
      .input-group.flex-nowrap
        input.form-control.form-control-plaintext.video-wrapper__user-name(
          ref="myName",
          type="text",
          v-model.trim="myName",
          :style="{ flex: `0 0 ${inputWidth}px` }",
          @click="onEdit",
          @input="updateName"
        )
        .input-group-append(v-if="editFlag")
          button.btn.video-wrapper__save-btn(
            type="button",
            @click="updateUsers"
          )
            | 保存
      //- 名前inputの横幅取得用
      .video-wrapper__hide-name(
        ref="hideName",
        contenteditable,
        tabindex="-1",
      )
        | {{ myName }}
    .video-wrapper__mic
      .video-wrapper__audio-level(v-if="localUser.micFlag")
        .video-wrapper__audio-level-item(:style="audioLevelHeight(0.6)")
        .video-wrapper__audio-level-item(:style="audioLevelHeight(1)")
        .video-wrapper__audio-level-item(:style="audioLevelHeight(0.6)")
      .video-wrapper__mic-circle(v-else)
        img.video-wrapper__mic-icon(src="/static/img/app/btn-microphone-slash.svg")
</template>

<script>
import $ from 'jquery'
import { getDecibel, getAudioLevelHeight } from '../../utils/audioLevel'

export default {
  name: 'LocalStream',
  data () {
    return {
      myName: '',
      editFlag: false,
      inputWidth: 0,
      decibel: -Infinity
    }
  },
  computed: {
    localStream () {
      return this.$store.state.localStream
    },
    peerId () {
      return this.$store.state.peerId
    },
    layoutCover () {
      return this.$store.getters.layoutCover
    },
    layoutSubFlag () {
      return this.$store.getters.layoutSubFlag(this.peerId)
    },
    localUser () {
      return this.$store.getters.localUser
    },
    localName () {
      return this.localUser?.name
    }
  },
  created () {
    this.updateDecibel()
    this.setMyName()
  },
  watch: {
    localStream () {
      this.updateDecibel()
    },
    localName () {
      this.setMyName()
    }
  },
  methods: {
    setMyName () {
      this.myName = this.localName
      this.updateName()
    },
    updateName () {
      this.$nextTick(() => {
        const $hideName = this.$refs.hideName
        const width = $hideName?.clientWidth || 0

        // 編集する場合は最小値を100に設定
        // 取得した横幅は小数点以下が削除されるため、+1する
        this.inputWidth = (this.editFlag && width < 100) ? 100 : width + 1
      })
    },
    changeMainStream () {
      this.$emit('event-changeMainStream', this.peerId)
    },
    showLocalName () {
      $('#js-local-name').modal('show')
    },
    onEdit () {
      this.editFlag = true
      this.updateName()
    },
    updateUsers () {
      if (!this.myName) return

      this.editFlag = false
      this.updateName()

      // 連続する半角スペースとタブを、1つの半角スペースに。連続する全角スペースを1つの全角スペースに
      this.myName = this.myName.replace(/[ \t]+/g, ' ')

      const payload = {
        type: 'users',
        peerId: this.peerId,
        data: {
          name: this.myName
        }
      }

      this.$store.state.room.send(payload)
      this.$store.dispatch('updateUsers', { payload })
      localStorage.setItem('goqmeLocalName', this.myName)
    },
    inputFile () {
      const $inputFile = this.$refs.inputFile
      $inputFile.click()
    },
    uploadImg (e) {
      // アイコン登録の処理
      const file = e.target.files[0]

      // キャンセルされた場合
      if (!file) return

      const reader = new FileReader()

      reader.onload = (e) => {
        const img = e.target.result

        this.$store.dispatch('updateIconImg', { img })
        $('#js-icon').modal('show')
      }
      reader.readAsDataURL(file)

      e.target.value = ''
    },
    removeIcon () {
      const payload = {
        type: 'users',
        peerId: this.$store.state.peerId,
        data: {
          icon: ''
        }
      }

      this.$store.state.room.send(payload)
      this.$store.dispatch('updateUsers', { payload })
      localStorage.removeItem('goqmeLocalIcon')
    },
    updateDecibel () {
      const self = this
      getDecibel(this.localStream, self)
    },
    audioLevelHeight (value) {
      return getAudioLevelHeight(this.decibel, value)
    }
  }
}
</script>
